<script lang="ts">
    import { Col,Button ,Tooltip} from "sveltestrap";
    import { BasicTooltip, HoverMe, Popovertitle } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={BasicTooltip} CardBodyprops="btn-showcase">
      <div slot="contentbody">
        <Button color="primary" id="hover">{HoverMe}</Button>
        <Tooltip target="hover" placement="top">{Popovertitle}</Tooltip>
      </div>
    </Card>
</Col>